module.exports = __webpack_public_path__ + "img/enhancement.72d9fc3c.jpg";